import React from 'react';
import { Bot, Wrench } from 'lucide-react';
import { AgentTool } from '../../types';

interface AgentToolIndicatorProps {
  tools: AgentTool[];
  className?: string;
  showCount?: boolean;
}

const AgentToolIndicator: React.FC<AgentToolIndicatorProps> = ({
  tools,
  className = '',
  showCount = true
}) => {
  const agentTools = tools.filter(tool => tool.type === 'agent');
  
  if (agentTools.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      <div className="flex items-center space-x-1">
        <Bot className="w-3 h-3 text-purple-500" />
        <Wrench className="w-3 h-3 text-purple-500" />
      </div>
      {showCount && (
        <span className="text-xs font-medium text-purple-600">
          {agentTools.length}
        </span>
      )}
    </div>
  );
};

export default AgentToolIndicator; 